<template>
  <div class="item-cells confirm-serve-info">
    <div class="item-layout" v-for="item in depList" :key="item.id">
      <div class="item-common-layout">
        <div class="item-common-content">
          <div class="block" @click="showSelect(item.id)">
            <label class="label-ui">{{ item.label }}</label>
            <div class="item-cell-bd">
              <div class="default" v-if="!item.value">
                {{ item.placeholder }}
              </div>
              <div v-else>
                <div v-if="item.id == 'ys'" class="yuesao-info">
                  <div class="img-head">
                    <img
                      :src="
                        $$viewImage(
                          decodeURIComponent(item.value.headImage),
                          56,
                          56
                        )
                      "
                      alt=""
                    />
                  </div>
                  <span>{{ item.value.name }}</span>
                </div>
                <p v-else>{{ item.value.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="icon-arr-r"></div> -->
      </div>
    </div>
    <!-- 服务天数 -->
    <div class="item-layout">
      <div class="item-common-layout">
        <div class="item-common-content">
          <div class="block">
            <label class="label-ui"> 服务天数 </label>
            <div class="item-cell-bd">
              <ul class="days-ui">
                <li>
                  <div class="fl-ui">
                    <p>{{ fillIn.serviceDays }}天</p>
                  </div>
                </li>
                <!-- <li v-for="item in  days" :key="item.id" :class="{selected: fillIn.days == item.id}">
                                   <div>
                                       <i></i>
                                        <p>{{item.id}}天</p>
                                   </div>
                               </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <mt-actionsheet
            :actions="yuesaoStarSelect"
            v-model="sheetVisible">
        </mt-actionsheet> -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Actionsheet } from 'mint-ui'
import isIOS from '@/plugins/isIOS'
import { GradeList } from '@/plugins/enum'
export default {
  props: {
    shareUid: {
      type: String,
      default: ''
    },
    fillIn: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    //const days = [{id:26},{id:42}]
    return {
      sheetVisible: false,
      yuesaoStarSelect: []
      //days
    }
  },
  computed: {
    ...mapState([
      'workers',
      'selectedWorker',
      'selectedTime',
      'selectedAddress',
      'locationInfo',
      'viewName',
      'selectedCoupon',
      'confirmProduct',
      'confirmCoupons',
      'confirmSelected'
    ]),
    ...mapState({
      depList: state =>
        state.confirmYuesao &&
        state.confirmYuesao.depList.filter((item, index) => index < 3)
    })
  },
  created() {
    const method = (v, index) => {
      const { name, id } = v
      const value = { name, id }
      try {
        this.setSelected({ id: 'dj', value })
      } catch (e) {
        console.log(e)
      }
    }
    this.yuesaoStarSelect = GradeList.map(item => {
      item.method = method
      return item
    })
    const query = this.$route.query

    if (query) {
      const paramsText = decodeURIComponent(query.params)
      const {
        cityId,
        cityName,
        serviceDays,
        headImage,
        workerName,
        workerCode,
        starLevel
      } = query

      this.setSelected({
        id: 'cs',
        value: {
          id: cityId,
          name: cityName
        }
      })
      const djGrade = this.yuesaoStarSelect.find(item => item.id == starLevel)
      console.log(djGrade)
      delete djGrade.method
      this.setSelected({ id: 'dj', value: djGrade })
      this.setSelected({
        id: 'ys',
        value: {
          name: workerName,
          id: workerCode,
          headImage
        }
      })
      this.fillIn.serviceDays = serviceDays
    }
  },
  mounted() {},
  methods: {
    ...mapMutations('confirmYuesao', ['setSelected']),
    ...mapActions('confirmYuesao', ['verificationDepList']),
    ...mapMutations([
      'showActionSheet',
      'changeView',
      'setActionHeader',
      'setSelectedWorker',
      'setSelectedTime',
      'setSelectedCoupon',
      'setConfirmCoupons',
      'resetConfirmCoupons'
    ]),
    async showSelect(id) {
      // 先不可选择
      // const verify = await this.verificationDepList(id)
      // if(id === 'cs' && verify) {
      //     this.showCity()
      // } else if(id === 'dj' && verify) {
      //     this.showGrade()
      // } else if(id === 'ys' && verify) {
      //     this.showWorker()
      // }
    },
    // showGrade(){
    //     this.sheetVisible = true
    // },
    // showCity() {
    //     this.changeView('confirmYuesaoCity')
    //     this.setActionHeader({
    //         title: '选择城市',
    //         show: false
    //     })

    //     this.$router.push({ query: { ...this.$route.query, action: true, viewName: this.viewName } })

    // },
    // showWorker() {
    //     this.changeView('confirmYuesaoWorkers')
    //     this.setActionHeader({
    //         title: '选择服务人员',
    //         show: false
    //     })
    //     // this.showActionSheet();
    //     this.$router.push({ query: { ...this.$route.query, action: true, viewName: this.viewName } })
    //     // 埋点
    //     const code = this.selectedWorker.workerCode || ''
    //     this.$$tracker('110101', '20000', 21033, code)

    // },
    showCoupon() {
      this.changeView('coupon')
      this.setActionHeader({
        title: '优惠券',
        show: false
      })
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
    },
    deleteCoupon() {
      this.setSelectedCoupon({})
    }
    // changeDays(item){
    //     this.fillIn.days = item.id
    // }
  },
  components: {
    [Actionsheet.name]: Actionsheet
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.confirm-serve-info {
  margin-bottom: rem(21px);
  padding: rem(18px) 0;
  padding-top: 0;
  border-radius: rem(16px);
  overflow: hidden;
  .item-layout:last-child {
    .item-common-layout {
      @include border(bottom, #fff, 0);
    }
  }
  .item-layout .item-common-content .item-cell-bd {
    font-weight: bold;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #999;
  }
  .yuesao-info {
    display: flex;
    align-items: center;
    .img-head {
      width: rem(56px);
      height: rem(56px);
      overflow: hidden;
      border-radius: 100%;
      margin-right: rem(12px);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    p {
      padding-left: rem(12px);
    }
  }
  .days-ui {
    display: flex;
    width: 100%;
    li {
      flex: 1;
      > div {
        display: flex;
        justify-content: flex-end;
        &.fl-ui {
          justify-content: flex-start;
        }
        i {
          width: rem(38px);
          height: rem(38px);
          background: url('~@/assets/images/evaluate/jingqi_selected_n@3x.png')
            no-repeat left center;
          background-size: 100% auto;
        }
        p {
          font-size: rem(28px);
          color: #121212;
          line-height: rem(40px);
          padding-left: rem(15px);
        }
      }
      &.selected {
        > div {
          i {
            background-image: url('~@/assets/images/evaluate/jingqi_selected@3x.png');
          }
        }
      }
    }
  }
}
</style>
